import { shiftEditorViewState } from "..";
import { Moment } from "moment";
import { mutatorAction } from "satcheljs";

export default mutatorAction("updateEndTimeTimeoff", function updateEndTimeTimeoff(endTime: Moment) {
    if (endTime) {
        shiftEditorViewState().timeOffEndTime = endTime.clone();
    }
});
